import React from 'react';
import HR from '../../Components/HR';

const Automation = () => {
    return (
        <div id='Contact'>
            <HR>Intelligent Automation</HR>
            <div className='grid grid-cols-12 gap-5 mx-auto md:my-16 my-10'>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>AR Reconciliation</h4>
                    <p className='text-center text-2xl mt-3'>Reduced the AR Recon process from 7FTE manual days to 1 hr of automation.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Legal Directory</h4>
                    <p className='text-center text-2xl mt-3'>Have automated the process to create new records and the documents.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Customer Onboarding</h4>
                    <p className='text-center text-2xl mt-3'>Have automated the costomer onboarding.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Document Controller</h4>
                    <p className='text-center text-2xl mt-3'>Automation of the work of Document controller's.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Recruitment Process</h4>
                    <p className='text-center text-2xl mt-3'>Have automated the process to create new records and the documents.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Payment Automation</h4>
                    <p className='text-center text-2xl mt-3'>Automating the payment by reading email and transaction the necessary payment.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Credit Check</h4>
                    <p className='text-center text-2xl mt-3'>Automated credit check process.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>A/C Payable</h4>
                    <p className='text-center text-2xl mt-3'>Automated the invoice processing method.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Hyper Volume Processing</h4>
                    <p className='text-center text-2xl mt-3'>Have processed 250k documents within a week using automation.</p>
                </div>
                <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-secondaryBG py-12 rounded-xl text-white p-5'>
                    <h4 className='text-center text-4xl font-bold'>Credit Claim Filing</h4>
                    <p className='text-center text-2xl mt-3'>Automated filing of a credit claim lawsuit on the judiciary portal.</p>
                </div>
            </div>
        </div>
    );
};

export default Automation;